<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.EditCategoryDialog.Headline' | translate : 'Edit category' }}">
    <div class="row">
      <div class="col-auto" style="max-width: 153px">
        <img src="data:image/png;base64,{{image.Data}}" style="width: 133px; height: 133px; object-fit: contain;" />
        <input #txtFile type="file" style="visibility:hidden" (change)="upload($event.target.files)" />
        <button mat-mini-fab title="{{ 'Turbo.Settings.EditCategoryDialog.tipChangeImage' | translate : 'Change image' }}"style="position: absolute; left: 61px; bottom: 5px;" (click)="beginUpload()">
          <mat-icon>autorenew</mat-icon>
        </button>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.EditCategoryDialog.txtName' | translate : 'Name' }}</mat-label>
          <input typeof="text" matInput [(ngModel)]="category.Name" [disabled]="isReadOnly" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.EditCategoryDialog.txtDescription' | translate : 'Description' }}</mat-label>
          <input typeof="text" matInput [(ngModel)]="category.Description" [disabled]="isReadOnly" />
        </mat-form-field>
      </div>
    </div>
  </t4-container>

  <t4-container title=" ">
    <mat-tab-group>
      <mat-tab label="{{ 'turbo.Settings.EditCategoryDialog.tabSettings' | translate : 'Settings'}}">
        <label style="margin-top: 25px" class="turboLabel">{{ 'turbo.Settings.EditCategoryDialog.lblSortOrder' | translate : 'Sort order' }}:</label>
        <mat-slider min="1" max="100" step="1"  discrete  style="margin-top: 25px; width: 250px" [disabled]="isReadOnly">
          <input matSliderThumb [(ngModel)]="category.SortOrder"/>
        </mat-slider>
      </mat-tab>
      <mat-tab label="{{ 'turbo.Settings.EditCategoryDialog.tabContent' | translate : 'Content'}}">
        <t4-data-table #tblContent [allowMultiSelect]="true" [rawData]="objectTypes" headline="" matSort matSortActive="Title" [allowPaging]="false" [allowFilter]="true" [allowExcel]="false" [allowAdd]="false" [autoGenerateColumns]="false" [filterFields]="['Title','Alias']">
          <ng-container matColumnDef="Title">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:200px;">{{ 'T4.Settings.EditCategoryDialog.colTitle' | translate : 'Title' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:200px;">{{ row.Title }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Id">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">Id</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Id }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Alias">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.EditCategoryDialog.colAlias' | translate : 'Alias' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Alias }}</mat-cell>
          </ng-container>
        </t4-data-table>
      </mat-tab>
      <mat-tab label="{{ 'turbo.Settings.EditCategoryDialog.tabContries' | translate: 'Countries'}}">
        <div style="margin:5px;">
          <h4>Displayed in Selected Countries</h4>
          <h5>(If none selected, it applies to all countries)</h5>
          <div *ngFor="let country of countries">
            <mat-checkbox type="checkbox" [(ngModel)]="country.selected" (change)="updateSelectedCountries()">
              {{ 'turbo.Settings.EditCategoryDialog.txtCountry_' + country.name | translate: country.name }} ({{ country.code }})
            </mat-checkbox>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </t4-container>
</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" style="margin: 5px;" (click)="save()" *ngIf="!isReadOnly">{{ 'T4.Settings.EditCategoryDialog.cmdSave' | translate : 'Save' }}</button>
    <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.EditCategoryDialog.cmdCancel' | translate : 'Cancel' }}</button>
  </mat-dialog-actions>
